import { render } from "./Index.vue?vue&type=template&id=07d6849f"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Pages/Components/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07d6849f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07d6849f', __exports__)) {
    api.reload('07d6849f', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=07d6849f", () => {
    api.rerender('07d6849f', render)
  })

}


export default __exports__